<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import ProjectModal from "@/components/modals/project/project-modal.vue";
import api from "@/helpers/api-rest/api.js";
import store from "@/state/store";

export default {
  page: {
    title: "Convocatorias",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ProjectModal,
  },
  data() {
    return {
      tableData: [],
      title: "Convocatorias",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        { key: "id", sortable: false, label: "#" },
        { key: "name", sortable: true, label: "Nombre" },
        // { key: "description", sortable: true, label: "Descripción" },
        { key: "project_type_id", sortable: false, label: "Tipo" },
        { key: "status", sortable: false, label: "Estado" },
        {
          key: "action",
          tdClass: "custom-table-action",
          sortable: false,
          label: "",
        },
      ],
      editMode: false,
      projectEdit: undefined,
      duplicateMode: false,
      essays_number: 0,
      loadingJustification: {},
      loadingParticipants: {},
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    showElement(roleId = []) {
      const role = store.getters["auth/role"];
      return roleId.includes(role.id);
    },
    loadDataFromApi() {
      const apiEndpoint = `/api/v1/projects`;
      api
        .get({ url: apiEndpoint })
        .then((response) => {
          const data = response?.data?.data;
          data.forEach((project) => {
            project.essays_number = project.essays ? project.essays.length : 0;
          });

          // Almacenar los datos en tableData
          this.tableData = data;
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    success(project) {
      console.log(project);
      this.loadDataFromApi();
    },

    addProject() {
      this.projectEdit = undefined;
      this.duplicateMode = false;
    },

    editProject(project) {
      project.role_ids = project?.roles?.map((item) => item?.id);
      this.projectEdit = project;
      this.duplicateMode = false;
    },

    duplicateProject(project) {
      this.projectEdit = project;
      this.duplicateMode = true;
    },
    updateFields() {
      // Si el usuario es administrador, añade al array de campos la columna Redacciones
      if (this.showElement([1])) {
        this.fields.splice(3, 0, {
          key: "numberEssays",
          sortable: false,
          label: "Redacciones",
        });
      }
    },
    /**
     * Export project justification to Excel
     * @param {Object} project - Project object with id
     */
    exportProjectJustification(project) {
      if (this.loadingJustification[project.id]) return;

      this.$set(this.loadingJustification, project.id, true);
      
      const token = localStorage.getItem("authToken");
      const baseUrl = process.env.VUE_APP_API_HOST;
      const url = `${baseUrl}/export-project/${token}/${project.id}`;
      
      // Open in new tab for download
      window.open(url, "_blank");
      
      // Reset loading state after a short delay
      setTimeout(() => {
        this.$set(this.loadingJustification, project.id, false);
      }, 2000);
    },

    /**
     * Export project participants to Excel
     * @param {Object} project - Project object with id
     */
    exportParticipants(project) {
      if (this.loadingParticipants[project.id]) return;

      this.$set(this.loadingParticipants, project.id, true);
      
      const token = localStorage.getItem("authToken");
      const baseUrl = process.env.VUE_APP_API_HOST;
      const url = `${baseUrl}/export-professorate-project/${token}/${project.id}`;
      
      // Open in new tab for download
      window.open(url, "_blank");
      
      // Reset loading state after a short delay
      setTimeout(() => {
        this.$set(this.loadingParticipants, project.id, false);
      }, 2000);
    },
  },
  mounted() {
    this.loadDataFromApi();
    // Set the initial number of items
    this.totalRows = this.tableData.length;
    this.updateFields();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <template v-slot:header-button>
        <button
          v-if="showElement([1])"
          v-b-modal.ModalProject
          @click="addProject()"
          class="btn btn-success"
        >
          <i class="fa fa-plus"></i> Añadir Convocatoria
        </button>
      </template>
    </PageHeader>
    <ProjectModal
      :project="projectEdit"
      :duplicate="duplicateMode"
      @success="success"
      @reset-duplicate="duplicateMode = false"
    />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label for="per-page-select" class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label for="search-input" class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      id="search-input"
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                      aria-label="Buscar proyectos"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                show-empty
                ref="projectTable"
              >
                <template v-slot:cell(project_type_id)="row">
                  <div v-if="row.item.project_type_id">
                    <b-badge
                      pill
                      :variant="
                        row.item.project_type_id === 1 ? 'info' : 'light'
                      "
                      class="ml-1"
                    >
                      {{ row.item.project_type.name }}
                    </b-badge>
                  </div>
                </template>
                <template v-slot:cell(numberEssays)="row">
                  <div class="text-center">
                    <b-badge pill variant="light">
                      {{ row.item.essays_number }}
                    </b-badge>
                  </div>
                </template>
                <template v-slot:cell(status)="row">
                  <div>
                    <b-badge
                      pill
                      :variant="row.item.status === 1 ? 'success' : 'danger'"
                      class="ml-1"
                    >
                      {{ row.item.status === 1 ? "Activo" : "Inactivo" }}
                    </b-badge>
                  </div>
                </template>
                <template v-slot:cell(action)="row">
                  <div class="d-flex align-items-center justify-content-start gap-3 action-buttons-container">
                    <!-- Edit Button -->
                    <b-button
                      v-if="showElement([1])"
                      v-b-modal.ModalProject
                      @click="editProject(row.item)"
                      variant="outline-primary"
                      size="sm"
                      class="action-btn"
                      v-b-tooltip.hover
                      title="Editar"
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    
                    <!-- Duplicate Button -->
                    <b-button
                      v-if="showElement([1])"
                      v-b-modal.ModalProject
                      @click="duplicateProject(row.item)"
                      variant="outline-info"
                      size="sm"
                      class="action-btn"
                      v-b-tooltip.hover
                      title="Duplicar"
                    >
                      <i class="mdi mdi-content-copy"></i>
                    </b-button>
                    
                    <!-- View Button -->
                    <router-link
                      :to="{
                        name: 'project-detail',
                        params: { id: row.item.id },
                      }"
                      class="btn btn-outline-success btn-sm action-btn"
                      v-b-tooltip.hover
                      title="Ver detalles"
                    >
                      <i class="mdi mdi-eye-outline"></i>
                    </router-link>
                    
                    <!-- External Link Button -->
                    <a
                      v-if="row.item.link"
                      :href="row.item.link"
                      class="btn btn-outline-secondary btn-sm action-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-b-tooltip.hover
                      title="Enlace a la convocatoria"
                    >
                      <i class="mdi mdi-web"></i>
                    </a>
                    
                    <!-- Justification Export Button -->
                    <b-button
                      v-if="showElement([1])"
                      @click="exportProjectJustification(row.item)"
                      variant="outline-warning"
                      size="sm"
                      class="action-btn"
                      :disabled="loadingJustification[row.item.id]"
                      v-b-tooltip.hover
                      title="Generar justificación con todos los proyecto finalizados de la convocatoria"
                    >
                      <template v-if="!loadingJustification[row.item.id]">
                        <i class="fas fa-file-excel"></i>
                        <span class="ml-1 d-none d-md-inline">Justificación</span>
                      </template>
                      <template v-else>
                        <div class="d-flex align-items-center">
                          <div
                            class="spinner-border spinner-border-sm text-warning"
                            aria-label="Cargando"
                            style="width: 0.875rem; height: 0.875rem"
                          ></div>
                          <span class="ml-1 d-none d-md-inline">Cargando...</span>
                        </div>
                      </template>
                    </b-button>
                    
                    <!-- Participants Export Button -->
                    <b-button
                      v-if="showElement([1])"
                      @click="exportParticipants(row.item)"
                      variant="outline-success"
                      size="sm"
                      class="action-btn"
                      :disabled="loadingParticipants[row.item.id]"
                      v-b-tooltip.hover
                      title="Generar lista de participantes con todos los proyecto finalizados de la convocatoria"
                    >
                      <template v-if="!loadingParticipants[row.item.id]">
                        <i class="fas fa-file-excel"></i>
                        <span class="ml-1 d-none d-md-inline">Participantes</span>
                      </template>
                      <template v-else>
                        <div class="d-flex align-items-center">
                          <div
                            class="spinner-border spinner-border-sm text-success"
                            aria-label="Cargando"
                            style="width: 0.875rem; height: 0.875rem"
                          ></div>
                          <span class="ml-1 d-none d-md-inline">Cargando...</span>
                        </div>
                      </template>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.action-buttons-container {
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: visible;
  gap: 0.75rem;
}

.action-btn {
  min-width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease-in-out;
  flex-shrink: 0;
  margin-right: 0.5rem;
}

.action-btn:last-child {
  margin-right: 0;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn i {
  font-size: 1rem;
}

.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.custom-table-action {
  min-width: 300px;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .action-btn {
    min-width: 32px;
    height: 32px;
    padding: 0.25rem 0.375rem;
  }
  
  .action-btn i {
    font-size: 0.875rem;
  }
  
  .action-btn span {
    display: none;
  }
  
  .custom-table-action {
    min-width: 200px;
  }
}
</style>
